const LOGIN = "/auth/login";
const FABRIC = "/fabrics";
const ADDFABRIC = "/fabrics/add";
const EDITFABRIC = "/fabrics/edit";
const DETAILFABRIC = "/fabrics/detail";
const DASHBOARD = "/dashboard";
const STYLEACCENT = "/styleaccent";
const DETAILSTYLEACCENT = "/styleaccent/detail";
const GENERATEQR = "/fabrics/qr";
const TEMPLATEQR = "/templateqr";

/* Transaction Routes */
const PENDINGTRANSACTION = "/transactions/pending";
const CONFIRMEDTRANSACTION = "/transactions/confirmed";
const CANCELEDTRANSACTION = "/transactions/canceled";
const REFUNDTRANSACTION = "/transactions/refund";
const TRANSACTIONPENDINGDETAIL = "/transactions/pending/:transactionId";
const TRANSACTIONCONFIRMDETAIL = "/transactions/confirmed/:transactionId";
const TRANSACTIONCANCELEDDETAIL = "/transactions/canceled/:transactionId";
const TRANSACTIONREFUNDDETAIL = "/transactions/refund/:transactionId";

// Style Options Routes
const STYLEOPTIONS = "/style-options";
const ADDSTYLEOPTIONS = "/style-options/add";
const EDITSTYLEOPTIONS = "/style-options/edit";
const DETAILSTYLEOPTIONS = "/style-options/detail";

// Menu Master Routes
// Sub-menu User
const USER = "/master/user";
const EDITUSER = "/master/user/edit_user";
const DETAILUSER = "/master/user/detail/:id";

// Sub-menu Administrator
const ADMINISTRATOR = "/master/administrator";
const ADDADMINISTRATOR = "/master/administrator/add_administrator";
const EDITADMINISTRATOR = "/master/administrator/edit_administrator";
const DETAILADMINISTRATOR = "/master/administrator/detail/:id";

// Sub-menu Product Category
const PRODUCTCATEGORY = "/master/product_category";
const ADDPRODUCTCATEGORY = "/master/product_category/add_product_category";
const EDITPRODUCTCATEGORY = "/master/product_category/edit_product_category";

// Sub-menu Product List
const PRODUCTLIST = "/master/product_list";
const ADDPRODUCTLIST = "/master/product_list/add_product_list";
const EDITPRODUCTLIST = "/master/product_list/edit_product_list";
// End Menu Master Routes

// Menu Reports
const REPORTDATA = "/reports";

// Settings Routes
const SETAPPEARANCE = "/settings/appearance";
const SETFABRICSTYLE = "/settings/fabric_style";
const ADDFABRICSET = "/settings/fabric_style/add_fabric";
const EDITFABRICSET = "/settings/fabric_style/edit_fabric";

// Error Pages
const NotFoundPage = "/not-found";
const NotHaveAccess = "/restricted";

export {
  ADDFABRICSET,
  EDITFABRICSET,
  LOGIN,
  DASHBOARD,
  FABRIC,
  STYLEACCENT,
  ADDFABRIC,
  EDITFABRIC,
  DETAILFABRIC,
  DETAILSTYLEACCENT,
  PENDINGTRANSACTION,
  CONFIRMEDTRANSACTION,
  CANCELEDTRANSACTION,
  REFUNDTRANSACTION,
  ADMINISTRATOR,
  ADDADMINISTRATOR,
  EDITADMINISTRATOR,
  DETAILADMINISTRATOR,
  USER,
  EDITUSER,
  DETAILUSER,
  PRODUCTCATEGORY,
  ADDPRODUCTCATEGORY,
  EDITPRODUCTCATEGORY,
  PRODUCTLIST,
  ADDPRODUCTLIST,
  EDITPRODUCTLIST,
  GENERATEQR,
  TEMPLATEQR,
  REPORTDATA,
  TRANSACTIONPENDINGDETAIL,
  TRANSACTIONCONFIRMDETAIL,
  TRANSACTIONCANCELEDDETAIL,
  TRANSACTIONREFUNDDETAIL,
  SETAPPEARANCE,
  SETFABRICSTYLE,
  NotFoundPage,
  NotHaveAccess,
  STYLEOPTIONS,
  ADDSTYLEOPTIONS,
  EDITSTYLEOPTIONS,
  DETAILSTYLEOPTIONS,
};
